//import $ from 'jquery';
$(document).ready(function () {
	/**
	 * Set the first child with class .mobile-note-slide of the parent #mobile-note-slides to active on page load and set it's opacity to 1.
	 * On click of the .mobile-note-slide set it to active if it is not currently active and set the opacity of the other .mobile-note-slide to 0.3,
	 * Set the background image of #whisky-notes to the image child of the active .mobile-note-slide with animation.
	 */
	$('#mobile-note-slides .mobile-note-slide:first-child').addClass('active').css('opacity', '1');
	$('#whisky-notes').css('background-image', 'url(' + $('#mobile-note-slides .mobile-note-slide.active img').attr('src') + ')');
	$('#mobile-note-slides .mobile-note-slide').click(function () {
		if (!$(this).hasClass('active')) {
			$('#mobile-note-slides .mobile-note-slide').removeClass('active').css('opacity', '0.3');
			$(this).addClass('active').css('opacity', '1');
			$('#whisky-notes').css('background-image', 'url(' + $(this).find('img').attr('src') + ')');
		}
	});
});